import { log } from "../../utils/log";
import {
    FETCH_ALUNO,
    FETCH_ALUNOS, GET_DISCOFFER_CONTENTDATES, POST_ALUNO, POST_ALUNO_PRE, RECEIVE_ALUNO,
    RECEIVE_ALUNOS,
    RECEIVE_DISCOFFER_CONTENTDATES,
} from "../actionTypes";
import axios from "../axiosApi";
import config from "../../config";
import {enrollmentLevelSchema} from "../../utils/enrollmentValidation";







export const fetchAlunos =  () => ({
    type: FETCH_ALUNOS
});

export const receiveAlunos = (payload: any) => ({
    type: RECEIVE_ALUNOS,
    payload: payload
});


export const fetchAluno =  () => ({
    type: FETCH_ALUNO
});

export const receiveAluno = (payload: any) => ({
    type: RECEIVE_ALUNO,
    payload: payload
});


export const postAlunoPre =  () => ({
    type: POST_ALUNO_PRE
});

export const postAlunoAfter = (payload: iAlunoPostResponse) => ({
    type: POST_ALUNO,
    payload: payload
});

export const getAlunos = () => {
    return async (dispatch : any, getState: any ) => {
        if (getState().isFetchingAlunos) { return null; }
        dispatch(fetchAlunos());
        let payload;

        try {
            log(3,"axios default", axios.defaults);
            log(3,"axios.default.headers",axios.defaults.headers.common['Authorization']);
            
            const url = `/persons/listaAlunosBase`;
            const response = await axios.get(url);
            log(3,'getAlunos response', response);
            payload = response.data
        }
        catch(e) {
            payload = [];
            console.log("getAlunos ERROR", e);

        }
        finally {
            dispatch(receiveAlunos(payload));
        }
    }
}

export const getAluno = (id: number) => {
    
    if (id === null) { return; }
    return async (dispatch : any) => {
        dispatch(fetchAluno());
        let payload;
    
        const q = JSON.stringify({
            "include": [
                { "enrollmentInLevel":  [
                        {"level":[ "schoolAuthorization", {"discipline": "disciplineModule"  } ] } ,
                        { "enrollment": [
                                "installments",
                                {"disciplineEntree":[
                                        "disciplineEntreeFrequency",
                                        { "disciplineEntreeAvaliacoes" : ["disciplineOfferContent", "tipoAvaliacao"]} ,
                                        {"disciplineOffer": ["period", "discipline", "classOffer", "teacher", "disciplineOfferContent",
                                                { "disciplineModule" : "discipline"  }
                                            ]}
                                    ]}
                            ]}
                    ]},
                 "user"
            ]
        });
        
        const url = `/Persons/${id}?filter=` + q;
        
        log(3,"url", url);
        
        try {
            const response = await axios.get(url);
            console.log('getAluno response', response);
            payload = response.data
        }
        catch(e) {
            payload = [];
            console.log("getAluno ERROR", e);
            
        }
        finally {
            dispatch(receiveAluno(payload));
        }
    }
}

export const postAluno = (data: any, pictureFile: string | null | undefined) => {
    return async (dispatch : any, getState: any) => {
        dispatch(postAlunoPre());
        let payload : iAlunoPostResponse = {};
        let response : any;
        let method: number = 0;
        let id : number = 0;
        let xerror : any;
        
        const user = data.user?? null;
        
        try {
            
            
           // debugger;
            if (typeof data.modifiedOn !== "undefined") { delete data.modifiedOn; }
            if (typeof data.modifiedOn !== "undefined") { delete data.createdOn; }
           
            //debugger;
            data.Name = data.Name?.toUpperCase() || "";
            data.NomeSocial = data.NomeSocial?.toUpperCase() || "";
                data.email = data.email?.toLowerCase() || "";
                data.MobileNumber = data.MobileNumber?.replace(/\D/g, '') || "";
                data.PhoneNumber = data.PhoneNumber?.replace(/\D/g, '') || "";
                data.Mother = data.Mother?.toUpperCase() || "";
                data.Father = data.Father?.toUpperCase() || "";
                data.BirthPlace = data.BirthPlace?.toUpperCase() || "";
                data.Nationality = data.Nationality?.toUpperCase() || "";
                data.IndividualIdentity = data.IndividualIdentity?.replace('.','').replace('-','').replace('/','').toUpperCase() || "";
                data.IdentityNumber = data.IdentityNumber?.toUpperCase() || "";
                data.IdentityEmitter = data.IdentityEmitter?.toUpperCase() || "";
                data.ElectionIdentity = data.ElectionIdentity?.replace('.','').replace('-','').replace('/','').toUpperCase() || "";
                data.ElectionZone = data.ElectionZone?.toUpperCase() || "";
                data.MilitarIdentity = data.MilitarIdentity?.replace('.','').replace('-','').replace('/','').toUpperCase()|| "";
                data.Address = data.Address?.toUpperCase() || "";
                data.Address2 = data.Address2?.toUpperCase() || "";
                data.StreetNumber = data.StreetNumber?.toUpperCase() || "";
                data.Neighborhood = data.Neighborhood?.toUpperCase() || "";
                data.City = data.City?.toUpperCase() || "";
                data.StateAddress = data.StateAddress?.toUpperCase() || "";
                data.WorkAt = data.WorkAt?.toUpperCase() || "";
                data.ProfAddress = data.ProfAddress?.toUpperCase() || "";
                data.ProfCity = data.ProfCity?.toUpperCase() || "";
                data.ProfPhone = data.ProfPhone?.replace('.','').replace('-','').replace('/','').toUpperCase() || "";
                
              
            
            if (data.enrollmentInLevel) { delete data.enrollmentInLevel; }
            if (data.user) { delete data.user; }
  
            if ((typeof data.id !== "undefined") && data.id !== null) {
                id = data.id;
                delete data.id
                
                method = 1;
                log(3,"calling postAluno.put", JSON.stringify(data));
                response = await axios.put(`/Persons/${id}`, data)
                    .catch( (error) => {
                        xerror = error;
                        if (error) { console.log(JSON.stringify(error,null,"\t"));}
                        // @ts-ignore
                        if (error.response) {
                            // @ts-ignore
                            console.log("error.response.data", JSON.stringify(error.response.data,null,"\t"));
                            // @ts-ignore
                            console.log("error.response.status", JSON.stringify(error.response.status,null,"\t"));
                            // @ts-ignore
                            console.log("error.response.header", JSON.stringify(error.response.header,null,"\t"));
                            // @ts-ignore
                            console.log("error.response.header", JSON.stringify(error.response,null,"\t"));
                        }
                        // @ts-ignore
                        if (e.error.request) { console.log(JSON.stringify(error.request,null,"\t"));}
                        return null;
                    })
            } else {
                method = 2;
                if (data.id === null) { delete data.id; }
               
                
                log(3,"calling postAluno.post", JSON.stringify(data));
                
                response = await axios.post(`/Persons`, data)
                    .catch( (error) => {
                        xerror = error;
                        if (error.response) {
                            // @ts-ignore
                            console.log("error.response.data", JSON.stringify(error.response.data,null,"\t"));
                            // @ts-ignore
                            console.log("error.response.status", JSON.stringify(error.response.status,null,"\t"));
                            // @ts-ignore
                            console.log("error.response.header", JSON.stringify(error.response.header,null,"\t"));
                            // @ts-ignore
                            console.log("error.response.header", JSON.stringify(error.response,null,"\t"));
                        }
                        // @ts-ignore
                        if (e.error.request) { console.log(JSON.stringify(error.request,null,"\t"));}
                        return null;
                    });
                id = response.data.id;
            }


     //       console.log('postAluno response', response)
            payload = { data: response.data }
        }
        catch( err ) {
            payload = { error: true };

            let r = {
                error: true,
            }
            console.error("postAluno ERROR", err);
            // @ts-ignore
            r = { ...r, ...xerror, errorResponse: err?.response }
            log(2,"postAluno ERROR full", r, JSON.stringify(r,null,4));

        }
        finally {
            
            if (pictureFile) {
              dispatch(postPictureFile(id, pictureFile));
            }
            
            if (user && user.password && user.password.length >= 4) {
                dispatch(postUserNewPassword(user.id, user.password));
            }
            
            dispatch(postAlunoAfter(payload));
            switch(method) {
                case 1: // put
                    if ( ( response.status === 200 ) ) {
                        
                        dispatch(getAluno(id));
                    }
                    break;
                case 2: // post
                    if ( (payload.data && (typeof payload.data.id !== "undefined") ) ) {
                        dispatch(getAluno(payload.data.id));
                       // dispatch(getItemLoteCaixas());
                    }
                    break;
            }
            
            
        }
    }
}

export const postPictureFile = ( personId: number, pictureFile: any) => {
    return async (dispatch : any, getState: any) => {
        const formData = new FormData();
        formData.append(`${personId}`, pictureFile);
        console.log('formdata', formData.getAll(`${personId}`));
        
        const uploadURL = `/PersonPics/${config.BUCKET_NAME}/upload`;
        
        var response = await axios.post(uploadURL, formData, {});
        const fileResp = response.data.result.files[personId][0];
        const fileName = fileResp.name;
        
        const patchUrl = `${config.BASE_URL}/Persons/${personId}`;
        const patchData = {
            'PictureFile': `/PersonPics/${config.BUCKET_NAME}/download/${encodeURIComponent(fileName)}`
        };
        response = await axios.patch(patchUrl, patchData);
    }
}

export const postUserNewPassword = (userId: number, newPassword: string) => {
    return async (dispatch : any, getState: any) => {
        
     
        let payload: any;
        
        let error: any;
        
        try {
            
            let xdata = {
               id: userId,
                newPassword: newPassword
            }
          
            
            let response = await axios.post(`/FermiUsers/setnewpassword`, xdata)
                .catch( (error) => {
                    if (error.response) {
                        
                        // @ts-ignore
                        console.log("error.response.data", JSON.stringify(error.response.data,null,"\t"));
                        // @ts-ignore
                        console.log("error.response.status", JSON.stringify(error.response.status,null,"\t"));
                        // @ts-ignore
                        console.log("error.response.header", JSON.stringify(error.response.header,null,"\t"));
                        // @ts-ignore
                        console.log("error.response.header", JSON.stringify(error.response,null,"\t"));
                    }
                    // @ts-ignore
                    if (e.error.request) { console.log(JSON.stringify(error.request,null,"\t"));}
                    return null;
                })
            
            var r = response? response.data : "no response";
            payload = { data: r }

        }
        catch( err ) {
            payload = { error: true };

            let r = {
                error: true,
            }

            // @ts-ignore
            r = { ...r, errorResponse: err?.response,  cerror: err }
            log(2,"postAluno ERROR full", r, JSON.stringify(r,null,4));
        }
    }
}

export const postAddMatricula = (personId: number, data: any) => {
    return async (dispatch : any, getState: any) => {
        if (getState().cadastros.aluno.id !==  personId) {
            return false;
        }
        const levelId = enrollmentLevelSchema.validateSync(data?.Level_id);
        dispatch(postAlunoPre());
        try {
            const xdata = {
                ...data,
               Level_id: levelId,
               dhDate: data.dhDate.toISOString().substring(0, 10) + ' 03:00:00',
               dhExpireDate: data.dhExpireDate.toISOString().substring(0, 10) + ' 03:00:00',
               dhVecto1aParcela: data.dhVecto1aParcela.toISOString().substring(0, 10) + ' 03:00:00',
               UsuarioFezMatricula: getState().auth.userId,
               Person_id: personId,
           }
            if (xdata.id) { delete xdata.id; }
            await axios.post(`/Enrollments/addmatricula`, xdata);
        } finally {
            dispatch(postAlunoAfter({}));
        }
        dispatch(getAluno(personId));
        return true;
    }
}

export function postAddMatriculaDisciplinas(personId: number, eId: number,  listaDees: number[]) {
    return async (dispatch : any, getState: any) => {
       // dispatch({ type: CREATE_STUDENT });
        dispatch(postAlunoPre());
        for(let value of listaDees) {
            try {
               
                let data = {
                    Enrollment_id: eId,
                    DisciplineOffer_id: value
                };
                await axios.post("/DisciplineEntrees/", data);
            } catch(e) {
                console.error(e);
            }
        }
       // dispatch({ type: CREATE_STUDENT_SUCCESS });
        dispatch(postAlunoAfter({}));
        dispatch(getAluno(personId));
       
    }
}


export const patchEnrollmentDate = (personId: number, enrollmentId: number, newDate: Date) => {
    return async (dispatch: any) => {
        try {
            await axios.patch(`/Enrollments/${enrollmentId}`, {
                dhDate: newDate.toISOString().substring(0, 10) + ' 03:00:00'
            });
            dispatch(getAluno(personId));
        } catch (e) {
            console.error("patchEnrollmentDate ERROR", e);
        }
    }
}

export const patchEnrollmentExpireDate = (personId: number, enrollmentId: number, newExpireDate: Date) => {
    return async (dispatch: any) => {
        try {
            await axios.patch(`/Enrollments/${enrollmentId}`, {
                dhExpireDate: newExpireDate.toISOString().substring(0, 10) + ' 03:00:00'
            });
            dispatch(getAluno(personId));
        } catch (e) {
            console.error("patchEnrollmentExpireDate ERROR", e);
        }
    }
}

export const getDiscOfferContentDates  = (eId: number)  => {
   
    return async (dispatch : any, getState: any) => {
        try {
            console.log("2getting content dates for enrollment", eId);
            const response = await axios.get(`/Enrollments/${eId}/getDiscOffContentDates`);
            const r = response.data;
            console.log("3got content dates for enrollment", eId, r);
            dispatch({ type: RECEIVE_DISCOFFER_CONTENTDATES, payload: r });
        } catch(e) {
            console.error('ERROR ACTION.getDiscOfferContentDates',e);
        }
    }
}
